import { cn } from "@/lib/utils";

interface StageProgressProps {
  currentStage: number;
  totalStages: number;
}

export const StageProgress = ({
  currentStage,
  totalStages,
}: StageProgressProps) => {
  return (
    <div className="flex items-center gap-1.5 px-4 py-3">
      {Array.from({ length: totalStages }).map((_, i) => (
        <div
          key={i}
          className={cn(
            "h-1.5 flex-1 rounded-full transition-all duration-300 ease-out",
            i < currentStage
              ? "bg-[hsl(var(--level-accent,45_100%_51%))]"
              : i === currentStage
                ? "bg-[hsl(var(--level-accent,45_100%_51%))]"
                : "bg-muted",
          )}
          style={
            i === currentStage
              ? {
                  color: "hsl(var(--level-accent, 45 100% 51%))",
                  animation: "glowPulse 2s ease-in-out infinite",
                }
              : undefined
          }
        />
      ))}
    </div>
  );
};
